import PlayControl from '../PlayControl';
import styles from './styles.module.scss';

export type BigPlayButtonProps = {
  onClick: () => void;
};

const BigPlayButton = ({ onClick }: BigPlayButtonProps) => {
  return (
    <div className={styles.bigPlayButton} data-testid='big-play-button'>
      <PlayControl paused onClick={onClick} />
    </div>
  );
};

export default BigPlayButton;
